import "./styles.css";
import { JEWEL_TYPES, JEWEL_CONFIG } from "./modules/config.js";
import { fetchExchangeRate, fetchLeagues } from "./modules/tradeService.js";
import { runAnalysis } from "./modules/engine.js";

const sizeSelect = document.getElementById("sizeSelect");
const targetSelect = document.getElementById("targetSelect");
const leagueSelect = document.getElementById("leagueSelect");
const topNSelect = document.getElementById("topNSelect");
const runBtn = document.getElementById("runBtn");
const stopBtn = document.getElementById("stopBtn");
const progressArea = document.getElementById("progressArea");
const progressFill = document.getElementById("progressFill");
const progressCount = document.getElementById("progressCount");
const progressCur = document.getElementById("progressCurrent");
const fetchingBadge = document.getElementById("fetchingBadge");
const topResultsArea = document.getElementById("topResultsArea");
const topCards = document.getElementById("topCards");
const logArea = document.getElementById("logArea");
const logBody = document.getElementById("logBody");
const emptyState = document.getElementById("emptyState");
const errorBanner = document.getElementById("errorBanner");
const rateBadge = document.getElementById("rateBadge");
const rateValue = document.getElementById("rateValue");
const sessionInput = document.getElementById("sessionInput");
const exportBtn = document.getElementById("exportBtn");
const sortByPrice = document.getElementById("sortByPrice");
const sortByListings = document.getElementById("sortByListings");
const minListingsInput = document.getElementById("minListingsInput");
// ── Dropdown Population ───────────────────────────────────────
function populateSizeDropdown() {
  sizeSelect.innerHTML = "";
  Object.keys(JEWEL_CONFIG).forEach((key) => {
    const opt = document.createElement("option");
    opt.value = key;
    opt.textContent = JEWEL_CONFIG[key].label;
    sizeSelect.appendChild(opt);
  });
}

function updateItemBases() {
  const selectedSize = sizeSelect.value;
  targetSelect.innerHTML = '<option value="">Select an item base...</option>';
  Object.keys(JEWEL_TYPES).forEach((key) => {
    const type = JEWEL_TYPES[key];
    if (type.sizes.includes(selectedSize)) {
      const opt = document.createElement("option");
      opt.value = key;
      opt.textContent = key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
      targetSelect.appendChild(opt);
    }
  });
}

populateSizeDropdown();
updateItemBases();
sizeSelect.addEventListener("change", updateItemBases);

// ── League dropdown ───────────────────────────────────────────
async function loadLeagues() {
  try {
    const leagues = await fetchLeagues();
    leagueSelect.innerHTML = '<option value="">Select a league...</option>';
    leagues.forEach((league) => {
      const opt = document.createElement("option");
      opt.value = league.id;
      opt.textContent = league.id;
      leagueSelect.appendChild(opt);
    });
  } catch (e) {
    leagueSelect.innerHTML = '<option value="">Select a league...</option>';
    ["Standard", "Hardcore", "Settlers", "Hardcore Settlers"].forEach(
      (name) => {
        const opt = document.createElement("option");
        opt.value = name;
        opt.textContent = name;
        leagueSelect.appendChild(opt);
      },
    );
  }
}

(async () => {
  await loadLeagues();
})();

// ── State ─────────────────────────────────────────────────────
let abortFlag = false;
let allResults = [];
let waitInterval = null;
let currentSort = "price";
let lastTopSnapshot = "";

// ── Helpers ───────────────────────────────────────────────────
function showError(msg) {
  errorBanner.textContent = msg;
  errorBanner.classList.add("visible");
}

function hideError() {
  errorBanner.classList.remove("visible");
}

function setRunning(on) {
  runBtn.disabled = on;
  runBtn.classList.toggle("hidden", on);
  stopBtn.classList.toggle("hidden", !on);
}

const medals = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X"];

function renderTopCards(results, topN, minListings) {
  const sorted = [...results]
    .filter((r) => r.total >= minListings)
    .sort((a, b) => b.average - a.average)
    .slice(0, topN);

  const snapshot = JSON.stringify(
    sorted.map((r) => r.url + r.average + r.total),
  );
  if (snapshot === lastTopSnapshot) return;
  lastTopSnapshot = snapshot;

  topCards.innerHTML = "";

  if (!sorted.length) {
    topCards.innerHTML =
      '<p style="color:var(--text-muted);font-style:italic;font-size:0.9rem;">No listings meet the minimum threshold yet.</p>';
    return;
  }

  sorted.forEach((r, i) => {
    const card = document.createElement("div");
    card.className = "result-card";
    card.innerHTML = `
      <p class="card-rank">Rank ${medals[i] ?? i + 1}</p>
      <div class="card-notables">${r.combo.map((n) => `<span class="notable-tag">${n}</span>`).join("")}</div>
      <div class="card-stats">
        <div class="stat"><span class="stat-label">Avg Price</span><span class="stat-value chaos">${Math.round(r.average)}</span></div>
        <div class="stat"><span class="stat-label">Listings</span><span class="stat-value">${r.total}</span></div>
      </div>
      ${r.url ? `<a class="card-link" href="${r.url}" target="_blank">View on Trade</a>` : ""}
    `;
    topCards.appendChild(card);
  });
}

function appendLogRow(index, r, scroll = true) {
  const tr = document.createElement("tr");
  const hasData = r.total > 0;
  tr.innerHTML = `
    <td style="color:var(--text-muted)">${index}</td>
    <td class="td-combo">${r.combo.join(" + ")}</td>
    <td class="td-total">${hasData ? r.total : "—"}</td>
    <td class="td-price">${hasData ? Math.round(r.average) + "c" : "—"}</td>
    <td>${r.url ? `<a href="${r.url}" target="_blank" style="color:var(--gold-dim);font-size:0.75rem;text-decoration:none;">↗</a>` : ""}</td>
  `;
  logBody.appendChild(tr);
  if (scroll) logBody.closest(".log-scroll").scrollTop = 9999;
}

// ── Sort ──────────────────────────────────────────────────────
function rebuildLog(minListings) {
  logBody.innerHTML = "";
  const sorted = [...allResults]
    .filter((r) => r.total >= minListings)
    .sort((a, b) =>
      currentSort === "price" ? b.average - a.average : b.total - a.total,
    );
  sorted.forEach((r, i) => appendLogRow(i + 1, r, false));
}

sortByPrice.addEventListener("click", () => {
  currentSort = "price";
  sortByPrice.classList.add("active");
  sortByListings.classList.remove("active");
  rebuildLog(parseInt(minListingsInput.value) || 1);
});

sortByListings.addEventListener("click", () => {
  currentSort = "listings";
  sortByListings.classList.add("active");
  sortByPrice.classList.remove("active");
  rebuildLog(parseInt(minListingsInput.value) || 1);
});

minListingsInput.addEventListener("input", () => {
  const minListings = parseInt(minListingsInput.value) || 1;
  lastTopSnapshot = "";
  rebuildLog(minListings);
  renderTopCards(allResults, parseInt(topNSelect.value), minListings);
});

// ── Export CSV ────────────────────────────────────────────────
function exportCSV() {
  if (!allResults.length) return;
  const rows = [["Notables", "Listings", "Avg Price (c)", "Trade URL"]];
  allResults
    .filter((r) => r.total > 0)
    .sort((a, b) => b.average - a.average)
    .forEach((r) => {
      rows.push([
        r.combo.join(" + "),
        r.total,
        Math.round(r.average),
        r.url || "",
      ]);
    });
  const csv = rows
    .map((r) => r.map((cell) => `"${cell}"`).join(","))
    .join("\n");
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `cluster-results-${Date.now()}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
exportBtn.addEventListener("click", exportCSV);

// ── Main ──────────────────────────────────────────────────────
async function main() {
  const league = leagueSelect.value;
  const target = targetSelect.value;
  const topN = parseInt(topNSelect.value);
  const sessId = sessionInput.value.trim();
  const sessIdRegex = /^[a-f0-9]{32}$/i;
  const size = sizeSelect.value;

  if (!league) {
    showError("Please select a league.");
    return;
  }
  if (!target) {
    showError("Please select an item base.");
    return;
  }
  if (!sessId) {
    showError("POESESSID is required.");
    return;
  }
  if (!/^[a-f0-9]{32}$/i.test(sessId)) {
    showError(
      "Invalid POESESSID — should be 32 characters (letters a-f and numbers).",
    );
    return;
  }

  hideError();
  abortFlag = false;
  allResults = [];
  currentSort = "price";
  lastTopSnapshot = "";

  setRunning(true);
  emptyState.classList.add("hidden");
  progressArea.classList.remove("hidden");
  topResultsArea.classList.add("hidden");
  logArea.classList.add("hidden");
  exportBtn.classList.add("hidden");
  topCards.innerHTML = "";
  logBody.innerHTML = "";
  progressFill.style.width = "0%";
  progressCount.textContent = "— / —";
  progressCur.textContent = "Fetching exchange rate…";
  fetchingBadge.classList.add("hidden");
  rateBadge.classList.add("hidden");
  sortByPrice.classList.add("active");
  sortByListings.classList.remove("active");

  let rate;
  try {
    rate = await fetchExchangeRate(league);
    rateValue.textContent = rate;
    rateBadge.classList.remove("hidden");
  } catch (e) {
    showError("Failed to fetch exchange rate. Check the league name.");
    setRunning(false);
    progressArea.classList.add("hidden");
    return;
  }

  let rowIndex = 0;

  try {
    await runAnalysis({
      size,
      typeKey: JEWEL_TYPES[target],
      league,
      exchangeRate: rate,
      sessionId: sessId,
      shouldAbort: () => abortFlag,

      onFetching: (combo) => {
        if (waitInterval) clearInterval(waitInterval);
        fetchingBadge.innerHTML = `<span class="spinner"></span> Fetching: ${combo.join(" + ")}...`;
        fetchingBadge.classList.remove("hidden");
      },

      onWait: (seconds) => {
        if (waitInterval) clearInterval(waitInterval);
        let remaining = seconds;
        fetchingBadge.innerHTML = `<span class="spinner"></span> Rate limiting. Waiting ${remaining}s...`;
        fetchingBadge.classList.remove("hidden");
        waitInterval = setInterval(() => {
          remaining--;
          if (remaining > 0) {
            fetchingBadge.innerHTML = `<span class="spinner"></span> Rate limiting. Waiting ${remaining}s...`;
          } else {
            clearInterval(waitInterval);
          }
        }, 1000);
      },

      onProgress: (cur, tot, combo, result) => {
        if (abortFlag) return;
        rowIndex++;
        const minListings = parseInt(minListingsInput.value) || 1;
        progressFill.style.width = `${(cur / tot) * 100}%`;
        progressCount.textContent = `${cur} / ${tot}`;
        progressCur.textContent = combo.join(" + ");
        allResults.push(result);

        if (rowIndex === 1) {
          logArea.classList.remove("hidden");
          topResultsArea.classList.remove("hidden");
        }

        appendLogRow(rowIndex, result);
        renderTopCards(allResults, topN, minListings);
      },
    });
  } catch (e) {
    if (!abortFlag) {
      showError("Analysis error: " + (e?.message ?? e));
      abortFlag = true;
      if (waitInterval) {
        clearInterval(waitInterval);
        waitInterval = null;
      }
      setRunning(false);
      fetchingBadge.classList.add("hidden");
      if (allResults.length) exportBtn.classList.remove("hidden");
    }
  }

  if (waitInterval) clearInterval(waitInterval);
  setRunning(false);
  fetchingBadge.classList.add("hidden");

  if (!abortFlag && allResults.length) {
    progressCur.textContent = "Analysis complete.";
    progressFill.style.width = "100%";
    exportBtn.classList.remove("hidden");
  }
}

runBtn.addEventListener("click", main);

stopBtn.addEventListener("click", () => {
  abortFlag = true;
  if (waitInterval) {
    clearInterval(waitInterval);
    waitInterval = null;
  }
  setRunning(false);
  fetchingBadge.classList.add("hidden");
  progressCur.textContent = "Analysis stopped.";
  if (allResults.length) exportBtn.classList.remove("hidden");
});